var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "900px",
        "close-on-click-modal": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        opened: _vm.fetchAll,
      },
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "下单率", name: "rate" } }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "15px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    on: { change: _vm.fetchAll },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "day" } }, [
                      _vm._v("最近30天"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "week" } }, [
                      _vm._v("最近3个月"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio-button", { attrs: { label: "month" } }, [
                      _vm._v("最近12个月"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "14px",
                  "margin-bottom": "10px",
                },
              },
              [_vm._v("下单率趋势")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.rateLoading,
                    expression: "rateLoading",
                  },
                ],
                staticStyle: { height: "350px" },
              },
              [
                _c("div", {
                  ref: "rateChart",
                  staticStyle: { width: "100%", height: "350px" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "14px",
                  margin: "15px 0 10px 0",
                },
              },
              [_vm._v("同比增长")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.yoyLoading,
                    expression: "yoyLoading",
                  },
                ],
                staticStyle: { height: "350px", "margin-top": "0" },
              },
              [
                _c("div", {
                  ref: "yoyChart",
                  staticStyle: { width: "100%", height: "350px" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "占比", name: "pie" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.pieLoading,
                    expression: "pieLoading",
                  },
                ],
                staticStyle: { display: "flex", height: "350px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "200px",
                      padding: "20px",
                      display: "flex",
                      "flex-direction": "column",
                      "justify-content": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-bottom": "16px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              color: "#909399",
                            },
                          },
                          [_vm._v("客户总数")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "28px",
                              "font-weight": "bold",
                              color: "#303133",
                            },
                          },
                          [_vm._v(_vm._s(_vm.pieTotal))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.pieList, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.name,
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            padding: "6px 0",
                            "border-bottom": "1px solid #f0f0f0",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("span", {
                                style: {
                                  display: "inline-block",
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "50%",
                                  background: item.color,
                                  marginRight: "8px",
                                },
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v(_vm._s(item.value))]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", {
                  ref: "pieChart",
                  staticStyle: { flex: "1", height: "350px" },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }